export enum NavigationPoint {
    assets = 'assets',
    home = 'home',
    collections = 'collections',
    collections_details = 'collections_details',
    collections_readonly = 'collections_readonly',
    login = 'login',
    userAdmin = 'userAdmin',
    error = 'Error',
}
